"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderBoxBase = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

var _Flex = require("../Flex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A `View` or `div` (depending on the platform) that has a common border
 * and padding set by default
 */
var BorderBoxBase = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "BorderBoxBase",
  componentId: "sc-1072ama-0"
})(["border:1px solid ", ";border-radius:2px;padding:", "px;", " ", ""], (0, _helpers.color)("black10"), (0, _helpers.space)(2), _styledSystem.border, _styledSystem.space);
exports.BorderBoxBase = BorderBoxBase;
//# sourceMappingURL=BorderBoxBase.js.map